<template>
  <div>
    <Breadcrumb :title="'Vesting'"></Breadcrumb>
    <VestingForm
      :ref="'VestingInfoForm'"
      :ProgramUnitClassJsonData="ProgramUnitClassJsonData"
      :VestingInfo="VestingJSON"
      :VestingModalLabel="modalConfig"
    ></VestingForm>
    <div>
      <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
    </div>
    <div class="btnDiv">
      <BaseToolBar :config="toolbarConfig" @buttonClicked="toolbarOnClick"></BaseToolBar>
    </div>
    <div>
      <BaseGrid
        :config="gridConfig"
        :excelExport="excelExport"
        :query="gridConfig.query"
        :mode="'editform'"
				:colorizeColumn=true
        @EditItem="EditVesting"
        @DeleteItem="DeleteItemfromGrid"
        @AttachItem="VestingAttachment"
      ></BaseGrid>
    </div>
    <VestingDocumentDropoffForm
      ref="vestingDocument"
      :docModalConfig="docModalConfig"
      :filterCondition="filterCondition"
      :transactionRecord="selectedVesting"
    ></VestingDocumentDropoffForm>
  </div>
</template>
<script>
import $ from "jquery";
import {
  VestingEventGridConfig,
  VestingEventToolbarConfig,
  VestingUpdateConfig
} from "./VestingEventConfig.js";
import BaseModelVesting from "@/models/BaseModelVesting.js";

import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import VestingForm from "@/components/forms/VestingForm.vue";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelDocument from "@/models/BaseModelDocument.js";
import { mapGetters, mapActions, mapState } from 'vuex';
import _ from 'lodash';
import { isNullOrUndefined } from 'util';

import VestingDocumentDropoffForm from "@/components/forms/VestingDocumentDropoffForm.vue";

export default {
  name: "VestingEvent",
  mixins: [apiUtil, funcUtil, toolbarUtility],
  computed:{
    ...mapGetters("getModule",["withFilter"]),
    ...mapState("postModule",["response"]),
  },
  components: {
    Breadcrumb,
    BaseGrid,
    BaseSearchBar,
    BaseToolBar,
    VestingForm,
    VestingDocumentDropoffForm
  },
  data: function() {
    return {
      gridConfig: VestingEventGridConfig,
      search: {
        SearchData: ""
      },
      vestingGridId: "vestingGrid",
      VestingMasterData: {},
      toolbarConfig: VestingEventToolbarConfig,
      BaseModelVesting: BaseModelVesting,
      BaseModelUnitClass: BaseModelUnitClass,
      modalConfig: {
        modalName: "",
        modalAddorEdit: ""
      },
      // Document dropoff modal
      docModalConfig: {
        modalName: "Vesting Documents",
        modalIdandRef: "docModal",
        isFooter: false
      },
      // Filter condition for Document dropoff modal
      filterCondition: {
        filter: "",
        limit: 500
      },
      VestingJSON: [],
      VestingEditJSON: {
        Id: null,
        BusinessEvent: "",
        ProgramId: null,
        PartnerId: null,
        ProgramTitle: "",
        PartnerFullName: "",
        UnitClass: "",
        UnitType: "",
        VestingType: "",
        UnitPool: "",
        Unit: null,
        VestStartDate: null,
        Year:null,
        VestedDate:null,
        Percentage:null,
        VestedUnit:null,
        SpecialArrangement:"",
        TransactionDate: null,
        Note:""
      },
      ProgramUnitClassJsonData: {
        option: []
      },
      selectedVesting:{},
    };
  },
  methods: {
    ...mapActions("postModule",['DeleteItem','UpdateAllItems']),

    UpdateVestingMasterData: function(fromFilter, filterMasterData) {
      if (fromFilter == true) {
        this.VestingMasterData = filterMasterData;
      } else {
        this.VestingMasterData = JSON.parse(
          JSON.stringify(
            $("#vestingGrid")
              .data()
              .kendoGrid.dataSource.data()
          )
        );
      }
      //Disable Rows which are not pending
      this._disableGridRow("vestingGrid","WorkflowStatus","neq","pending")
    },
    toolbarOnClick: function(e) {
      e.preventDefault();
      switch (e.id) {
        case "btnAddVesting":
          this.AddVesting();
          window.$("#BaseModal").modal("toggle");
          break;
        case "btnApproveVesting":
          this.ApproveVesting();
          break;
        case "btnBulkAttachment":
          this.AttachBatchDocuments();
          break;
        case "btnBulkImportVesting":
          // this._AlertPopup("Bulk import screen is in progress...");   
          this.$router.push("/event/vesting/bulkupload");        
          break;
        // case "btnRefresh":
        // 	this.refreshGrid();
        // 	break;
      }
      this._baseToolBarEvents("vestingGrid", ...arguments);
    },

    ApproveVesting: function() {
      let grid = $("#vestingGrid").data("kendoGrid");
      let selectedItem = [];
      grid.select().each(function() {
        let selectedDataItem = JSON.parse(JSON.stringify(grid.dataItem(this)));
        if (selectedDataItem.WorkflowStatus == "Pending") {
          //if (selectedDataItem.SpecialArrangement !='Override') {
           selectedDataItem.VestingLogged = "Completed";
          //} 
          selectedDataItem.Status = "Processing";
          //push the dataItem into the array
          selectedItem.push(selectedDataItem);
        }
      });
      if (selectedItem.length > process.env.VUE_APP_ApprovalLimitCount) {
        this._AlertPopup(`You can only Approve ${process.env.VUE_APP_ApprovalLimitCount} records at a time`, "info");
        return;
      }
      if (selectedItem.length <= 0) {
        this._AlertPopup("Please select atleast one pending item.", "info");
      } else {
        const message =
          "Are you sure you want to approve the selected record(s)?";
        this._ConfirmationPopup(message, "APPROVE").then(result => {
          if (result.value) {
            //let loader = this.$loading.show();
             this._APICrudPopup("APICrudpopup");
            //need to update the DB
            console.log(selectedItem);
            //using Update All method
            let updateobject = {
              Vesting: { config: VestingUpdateConfig, 
              updateData: selectedItem,
              processInBatches:true }
            };
            this.UpdateAllItems(updateobject).then(response => {
              //refresh the grid data only after the update gets completed
                $("#vestingGrid").data().kendoGrid.dataSource.read();
              this._AlertPopup("Submitted for Processing Successfully!", "success");
            }).catch(error=>{
              this._AlertPopup("Some Error Occurred!","info");
            }).finally(()=>{
              //loader.hide();
            })
          }
        });
      }
    },

    filterGrid: function() {
      let self = this;

      let currentMasterdata = this.VestingMasterData;

      let filteredData = this._filterGrid(
        this.VestingMasterData,
        this.search.SearchData
      );
      $("#vestingGrid")
        .data("kendoGrid")
        .dataSource.data(filteredData);
      this.UpdateVestingMasterData(true, currentMasterdata);
    },
    AddVesting: function() {
      this.modalConfig.modalName = "Add Vesting";
      this.modalConfig.modalAddorEdit = "add";
      this.ProgramUnitClassJsonData.option = [];
      const VestingAddJSON = {
        Id: null,
        BusinessEvent: "",
        ProgramId: null,
        ReceiverId: null,
        ProgramTitle: "",
        ReceiverFullName: "",
        UnitClass: "",
        UnitType: "",
        VestingType: "",
        UnitPool: "",
        Unit: 0,
        Percentage:0,
        TransactionDate: null,
        Status: "",
        TreasuryUnits: 0,
        VestedUnit:0,
        VestedDate:null,
        SpecialArrangement:"Override",
        Note: "",
        ProgramAlias: "",
        ProgramEIN: "",
        ProgramFormationDate: "",
        ProgramFinalCloseDate: "",
        ProgramMultiClass: "",
        ProgramIncomeSource: "",
        ProgramStateSource: "",
        PartnerFirstName: "",
        PartnerMiddleName: null,
        PartnerLastName: "",
        PartnerEntityName: null,
        PartnerFullName: "",
        PartnerTaxId: "",
        PartnerTSDocId: "",
        PartnerDomestic: "",
        PartnerPartnerStatus: null,
        PartnerHireDate: "",
        PartnerLeaveDate: null,
        PartnerEMail: "",
        PartnerAddress1: "",
        PartnerAddress2: null,
        PartnerCity: "",
        PartnerState: "",
        PartnerPostalCode: null,
        PartnerCountry: "",
        PartnerMailAddress1: "",
        PartnerMailAddress2: null,
        PartnerMailCity: "",
        PartnerMailState: "",
        PartnerMailPostalCode: null,
        PartnerMailCountry: ""
      };
      this.$refs.VestingInfoForm.Units = 0;
      this.VestingJSON = VestingAddJSON;
    },
    EditVesting: function(e) {
      e.preventDefault();
      this.modalConfig.modalName = "Edit Vesting";
      this.modalConfig.modalAddorEdit = "edit";

      let gview = window.$("#vestingGrid").data("kendoGrid");
      // var dataItem1 = gview.dataItem(window.$(e.currentTarget).closest("tr"));
      let dataItem = JSON.parse(
        JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr")))
      );
      dataItem.TreasuryUnits = 500; // Hardcoded value for demo

      this.VestingEditJSON = dataItem;
      this.VestingEditJSON.Percentage = Number(dataItem.Percentage);
      //this.partnerAutoCompleteDisplayedValue.displayedValue = this.VestingEditJSON.ReceiverFullName;
      //this.programAutoCompleteDisplayedValue.displayedValue = this.VestingEditJSON.ProgramTitle;
      this.ProgramUnitClassJsonData.option = [];
      this.ProgramUnitClassJsonData.option=this.withFilter(BaseModelUnitClass.list, {
        filter: "ProgramId eq " + dataItem.ProgramId
      })
      this.VestingJSON = this.VestingEditJSON;
      this.$refs.VestingInfoForm.calculateUnits(this.VestingJSON);
      window.$("#BaseModal").modal("toggle");
    },
    DeleteItemfromGrid: function(e) {
      e.preventDefault();
      //alert("Delete button clicked from BaseGrid..");
      const message = "Are you sure you want to delete this record?";
      this._ConfirmationPopup(message, "DELETE").then(result => {
        if (result.value) {
          //let loader = this.$loading.show();
           this._APICrudPopup("APICrudpopup");
          let gview = window.$("#vestingGrid").data("kendoGrid");
          let dataItem = gview.dataItem(
            window.$(e.currentTarget).closest("tr")
          );
          let deleteData = { Id: dataItem.Id };
          let ItemsToBeDeleted = { list:BaseModelVesting, payload:deleteData }
          this.DeleteItem(ItemsToBeDeleted).then(response => {
              $("#vestingGrid").data().kendoGrid.dataSource.read();
              this._AlertPopup("Deleted successfully!","success");
          }).catch(error=>{
              this._AlertPopup("Some Error Occurred!","info");
          }).finally(()=>{
            //loader.hide();
          })
        }
      });
    },
    // Vesting Documnet Dropoff
    VestingAttachment: function(e) {
      let self = this;
      e.preventDefault();
      const gview = window.$("#vestingGrid").data("kendoGrid");
      const dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

      this.selectedVesting={...dataItem};
            //TEMP: Only for Transfer Page.. Building Partner Record for the Time Being
      this.selectedVesting.PartnerTitle=dataItem.ReceiverFullName,
      this.selectedVesting.PartnerId=dataItem.ReceiverId
      this.selectedVesting.TransactionID=dataItem.Id

      // this.filterCondition.filter = `BusinessEvent eq 'Vesting' and TransactionID eq ${
      //   dataItem.Id
      // }`;
      this.filterCondition.batchQuery=true;

      let BatchGUIDArray=self.GetBatchGUIDArray(this.selectedVesting.BatchGUID);

      this.filterCondition.filter = function(o){
          return o.BusinessEvent=='Vesting' && (o.TransactionID == dataItem.Id || BatchGUIDArray.includes(o.BatchGUID))
      }

      this.$refs.vestingDocument.$refs.vestingDocumentMgr.resetDropZoneGrid();
      window.$("#docModal").modal("toggle");
    },
    AttachBatchDocuments(){

      let selectedItem = [];
      let selectedRowCount=0;

        //Get Next Batch Id
          const result = this.withFilter(BaseModelDocument.list,"");
          let batchId = (result.length <= 0) ? 1 : this._getIncrementalID(result,"BatchGUID");

          //Partner Program Concatenated List Change
          let programIdlist = new Set();
          let partnerIdList = new Set();

          let grid = $("#vestingGrid").data("kendoGrid");
              grid.select().each(function () {
              selectedRowCount++;
              let selectedDataItem = JSON.parse(JSON.stringify(grid.dataItem(this)));
              let tempBatchId = [];
              if (!isNullOrUndefined(selectedDataItem.BatchGUID) && !selectedDataItem.BatchGUID=="") {
                  tempBatchId = selectedDataItem.BatchGUID.split(",");
              }
              tempBatchId.push(batchId);
              selectedDataItem.BatchGUID = tempBatchId.toString();

              selectedItem.push(selectedDataItem);
              programIdlist.add(selectedDataItem.ProgramId);
              partnerIdList.add(selectedDataItem.ReceiverId);
              });

          if (selectedRowCount<=1) {
              this._AlertPopup("Please Select Atleast 2 Rows","info");
          }else{
            const batchConfig = {
              Vesting: {
               config: VestingEventGridConfig,
               updateData: selectedItem
              }
                };

                this.selectedVesting={};
                this.selectedVesting.ProgramId=null
                this.selectedVesting.PartnerId=null
                this.selectedVesting.ProgramIdList=[...programIdlist].toString();
                this.selectedVesting.PartnerIdList=[...partnerIdList].toString();
                this.selectedVesting.TransactionID=null
                this.selectedVesting.BusinessEvent="Vesting"
                this.selectedVesting.Type="batch"
                this.selectedVesting.BatchGUID=batchId;
                this.selectedVesting.batchConfig=batchConfig
                this.selectedVesting.parentGridId="vestingGrid"

                this.filterCondition.batchQuery=false;

                this.filterCondition.filter = `BusinessEvent eq 'Vesting' and BatchGUID eq ${
                batchId
            }`;
            
            this.$refs.vestingDocument.$refs.vestingDocumentMgr.resetDropZoneGrid();

            window.$("#docModal").modal("toggle");
                
            }  
        }
  },
  mounted() {
    let self = this;
    //changes for Toolbar
    self._loadGridSettings(self.vestingGridId);

    //bind databound event to grid
    let grid = $("#vestingGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateVestingMasterData);
    grid.dataSource.fetch();
  },
};
</script>

